import { type BaseProductElementProps } from "~/domains/product/types/BaseProductElementProps";
import { useProductContext } from "~/domains/product/ProductContext";
import { getPrimaryImage } from "~/utils/product/getPrimaryImage";
import { IMG_MISSING_PRODUCT } from "~/utils/url/staticResources";
import { useForcedConfiguratorTranslations } from "~/features/configurator/common/useXmlConfiguratorTranslations";
import {
  type ConfiguratorProductData,
  isConfiguratorProduct,
  type ProductData,
} from "~/domains/product/types/ProductData";
import { ConfiguratorType } from "~/domains/configurator/types/ConfiguratorType";
import { RAIL_CONFIGURATOR_PRODUCT_CODE } from "~/domains/configurator/constants";
import { Suspense } from "react";
import { styled } from "~/common/mui";

interface Props extends BaseProductElementProps {
  size: number | string;
}

function isNewTypeConfiguratorProduct(product: ProductData): product is ConfiguratorProductData {
  return (
    isConfiguratorProduct(product) &&
    (product.configuratorType === ConfiguratorType.MetricShaft ||
      product.configuratorType === ConfiguratorType.InchShaft)
  );
}

const PrimaryImageInner = (props: Props) => {
  const product = useProductContext(props);
  // TODO - Fix this so it doesn't have to use the rail configurator product code
  const xmlT = useForcedConfiguratorTranslations(
    isConfiguratorProduct(product) ? product.code : RAIL_CONFIGURATOR_PRODUCT_CODE,
  )?.t;

  let imageUrl = IMG_MISSING_PRODUCT;
  const image = getPrimaryImage(product, { imageFormat: "thumbnail" });
  if (image) {
    if (isNewTypeConfiguratorProduct(product)) {
      imageUrl = xmlT?.(image.url) ?? image.url;
    } else {
      imageUrl = image.url;
    }
  }

  return <Img className={props.className} src={imageUrl} alt={image?.altText} size={props.size} />;
};

const Img = styled("img", { shouldForwardProp: (prop) => prop !== "size" })<{ size: number | string }>(({ size }) => ({
  width: size,
  height: size,
  objectFit: "contain",
}));

export const PrimaryImageV2 = (props: Props) => {
  return (
    <Suspense fallback={null}>
      <PrimaryImageInner {...props} />
    </Suspense>
  );
};
